import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { BillingPanel } from "./BillingPanel";

// One dialog for the whole dashboard; opened with openBilling() (Settings, banner, or a plan-limit error).
export const BillingDialog = () => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  useEffect(() => {
    const onOpen = (e) => { setReason(e.detail?.reason || ""); setOpen(true); };
    window.addEventListener("cj-open-billing", onOpen);
    const q = new URLSearchParams(window.location.search);
    if (q.get("billing") === "open") {
      setOpen(true);
      q.delete("billing");
      window.history.replaceState(null, "", window.location.pathname + (q.toString() ? `?${q}` : ""));
    }
    return () => window.removeEventListener("cj-open-billing", onOpen);
  }, []);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="billing-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Plan &amp; billing</DialogTitle>
          <DialogDescription>Prices are in Australian dollars. Every plan has every feature.</DialogDescription>
        </DialogHeader>
        {reason && (
          <p className="flex items-start gap-2 rounded-lg bg-amber-500/10 text-amber-800 dark:text-amber-300 px-3 py-2 text-sm" data-testid="billing-limit-reason">
            <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" /> {reason}
          </p>
        )}
        {open && <BillingPanel onDone={() => setOpen(false)} />}
      </DialogContent>
    </Dialog>
  );
};
